import { render, staticRenderFns } from "./notification-IssueTaskAssigned.vue?vue&type=template&id=10b6f93e&scoped=true"
import script from "./notification-IssueTaskAssigned.vue?vue&type=script&lang=js"
export * from "./notification-IssueTaskAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b6f93e",
  null
  
)

export default component.exports